import { createStorage } from '@meteor/storage';

export let lastInstanceIdStore = createStorage<string>('lastInstanceId');
